import React, { useCallback, useEffect, useRef, useState } from 'react'
import ApiService from '../../../../ApiService.js'
import { useStates } from '../../../../StateProvider.js'
import { useViewPort } from '../../../../ViewportProvider.js'
import { TRIP_URL } from '../../../../constants.js'
import '../../../../scss/gps.scss'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'
import './ResizeContainer.css'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

const centralTimeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Chicago',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
  hour12: true
})

const AddressTable = (props) => {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  const { showToast } = useStates()
  const [currentLocation, setCurrentLocation] = useState('')
  const [timeZone, setTimeZone] = useState('')
  const [centralTime, setCentralTime] = useState(() =>
    centralTimeFormatter.format(new Date())
  )

  useEffect(() => {
    const tick = () => setCentralTime(centralTimeFormatter.format(new Date()))
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [])

  const elementParentRefs = useRef(
    Array.from({ length: 6 }, () => React.createRef())
  )
  const elementRefs = useRef(Array.from({ length: 6 }, () => React.createRef()))

  // const emulator = useEmulatorStore.getState().connectedEmulator

  const updatedProgressPercentage = useEmulatorStore(
    (state) => state.updatedProgressPercentage
  )
  const updatedProgressTime = useEmulatorStore(
    (state) => state.updatedProgressTime
  )

  // Current location lat and lng
  const emulatorLatitude = useEmulatorStore((state) => state.emulatorLatitude)
  const emulatorLongitude = useEmulatorStore((state) => state.emulatorLongitude)

  // Emulator those has trip
  const updatedHasTripEmulatorSsid = useEmulatorStore(
    (state) => state.updatedHasTripEmulatorSsid
  )

  // Get emulator details here
  const getSelectedEmulator = useEmulatorStore(
    (state) => state.selectedEmulator
  )

  useEffect(() => {
    if (
      updatedProgressPercentage === 100 ||
      updatedProgressPercentage === 99.99
    ) {
      showToast('Trip has been completed', 'success')
    }
  }, [updatedProgressPercentage])

  useEffect(() => {
    // Get current address from current lat and lng
    const fetchCurrentLocation = async () => {
      const geocodeAPI = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${emulatorLatitude},${emulatorLongitude}&key=${process.env.REACT_APP_GOOGLE_APIS_KEY}`

      const timestamp = Math.floor(Date.now() / 1000) // Current timestamp in seconds
      const timeZoneAPI = `https://maps.googleapis.com/maps/api/timezone/json?location=${emulatorLatitude},${emulatorLongitude}&timestamp=${timestamp}&key=${process.env.REACT_APP_GOOGLE_APIS_KEY}`

      try {
        // Get Address from Lat/Lng
        const [geocodeResponse, timeZoneResponse] = await Promise.all([
          fetch(geocodeAPI),
          fetch(timeZoneAPI)
        ])

        const [geocodeData, timeZoneData] = await Promise.all([
          geocodeResponse.json(),
          timeZoneResponse.json()
        ])

        // Handle geocode response
        if (geocodeData.status === 'OK' && geocodeData.results.length > 0) {
          setCurrentLocation(geocodeData.results[0].formatted_address)
        } else {
          console.error('Geocode API Error:', geocodeData.status)
        }
        // Handle time zone response
        if (timeZoneData.status === 'OK') {
          setTimeZone(timeZoneData.timeZoneName.split(' ').map(word => word[0]).join(''))
        } else {
          console.error('Time Zone API Error:', timeZoneData.status)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchCurrentLocation()
  }, [emulatorLatitude, emulatorLongitude])

  // const { handleButtonClick, isSpinning } = props
  const { width } = useViewPort()
  // const breakpoint = 620
  // const isMobile = width < breakpoint
  const arrWidth = width - 25 // 25 is the width of the handles between each
  const widthArr = new Array(6).fill(arrWidth / 6)

  for (let i = 0; i < 6; i++) {
    let savedAddressWithI = localStorage.getItem(`addressWidth${i}`)
    if (savedAddressWithI === null || savedAddressWithI === undefined) {
      savedAddressWithI = arrWidth / 6
      localStorage.setItem(`addressWidth${i}`, arrWidth / 6)
    }
    widthArr[i] = savedAddressWithI
  }

  const getAddress = (address) =>
    address?.map((component) => component?.long_name || '').join(', ') || 'N/A'

  const setValues = useCallback((emulator, tripData, isHover) => {
    const currentAddress =
      emulator && emulator.address ? emulator.address : 'N/A'

    const fromAddress = tripData ? getAddress(tripData.fromAddress) : 'N/A'

    const toAddress = tripData ? getAddress(tripData.toAddress) : 'N/A'

    // Storing from and to address
    localStorage.setItem('fromAddress', fromAddress)
    localStorage.setItem('toAddress', toAddress)

    // NOTE: CONVERTING DEPART TIME AND ARRIVAL TIME TO UTC THEN TO READABLE...
    const arrivalDepartTime =
      emulator?.departTime && emulator?.arrivalTime
        ? dayjs(emulator.departTimeInUtc).utcOffset(0) // Ensure it starts in UTC
          .tz('America/Chicago') // Convert to America/Chicago timezone
          .format('MMM D, YYYY, h:mm A') + '<br/>' +
          dayjs(emulator.arrivalTimeInUtc).utcOffset(0) // Ensure it starts in UTC
            .tz('America/Chicago') // Convert to America/Chicago timezone
            .format('MMM D, YYYY, h:mm A') + '<br/>'
        : 'N/A'

    console.log(
      'emulator',
      emulator?.departTimeInUtc,
      emulator?.arrivalTimeInUtc
    )

    const { remainingTime, remainingDistance } = calculateRemainingDistance(
      tripData,
      emulator
    )

    setStringToElementRef(currentAddress, elementRefs.current[0])
    setStringToElementRef(fromAddress, elementRefs.current[1])
    setStringToElementRef(toAddress, elementRefs.current[2])
    setStringToElementRef(arrivalDepartTime, elementRefs.current[3])
    setStringToElementRef(remainingTime, elementRefs.current[4])
    setStringToElementRef(remainingDistance, elementRefs.current[5])

    // loop through the element refs and set their background color to lightblue
    elementParentRefs.current.forEach((elementRef) => {
      if (elementRef.current) {
        if (isHover) {
          elementRef.current.style.backgroundColor = '#E4E5E9'
        } else if (
          emulator &&
          emulator.id === useEmulatorStore.getState().selectedEmulator?.id
        ) {
          elementRef.current.style.backgroundColor = '#E4E5E9'
        } else {
          elementRef.current.style.backgroundColor = 'transparent'
        }
      }
    })
  }, [])

  // function which sets the string to the passed element ref
  function setStringToElementRef(string, elementRef) {
    if (elementRef.current) {
      elementRef.current.innerHTML = string
    }
  }
  // function which sets the element ref's value to a loader
  function showLoaders() {
    elementRefs.current.forEach((elementRef) => {
      if (elementRef.current) {
        elementRef.current.innerHTML = `<div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>`
      }
    })
  }

  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )
  const hoveredEmulatorRef = useRef(useEmulatorStore.getState().hoveredEmulator)
  const tripDataRef = useRef(useEmulatorStore.getState().tripData)

  console.log('tripDataRefTesting:', tripDataRef.current)

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.tripData,
        (tripData) => {
          tripDataRef.current = tripData
          if (
            hoveredEmulatorRef.current !== null &&
            hoveredEmulatorRef.current !== undefined
          ) {
            return
          }
          if (hoveredEmulatorRef.current === null) {
            setValues(
              connectedEmulatorRef.current
                ? connectedEmulatorRef.current
                : useEmulatorStore.getState().selectedEmulator,
              tripData
            )
          }
        }
      ),
    [setValues]
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.connectedEmulator,
        (connectedEmulator) => {
          connectedEmulatorRef.current = connectedEmulator
          if (hoveredEmulatorRef.current === null) {
            setValues(
              connectedEmulatorRef.current
                ? connectedEmulatorRef.current
                : useEmulatorStore.getState().selectedEmulator,
              tripDataRef.current
                ? tripDataRef.current
                : useEmulatorStore.getState().tripData
            )
          }
        }
      ),
    [setValues]
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.hoveredEmulator,
        (hoveredEmulator) => {
          async function fetchAndUpdateTableValues(hoveredEmulator) {
            showLoaders()
            const token = localStorage.getItem('token')
            const { data, error } = await ApiService.makeApiCall(
              TRIP_URL,
              'POST',
              { distance: 0 },
              token,
              hoveredEmulator.id
            )
            if (error) {
              console.error('Error fetching trip data', error)
              if (hoveredEmulatorRef.current !== null) {
                setValues(hoveredEmulator, null, true)
              }
              return
            }
            if (data === null || data === undefined) {
              console.error('Data is null or undefined')
              if (hoveredEmulatorRef.current !== null) {
                setValues(hoveredEmulator, null, true)
              }
              return
            }
            if (
              data.data.tripPoints === null ||
              data.data.tripPoints === undefined ||
              data.data.tripPoints.length === 0
            ) {
              console.error('Trip points are null or undefined or empty')
              if (hoveredEmulatorRef.current !== null) {
                setValues(hoveredEmulator, null, true)
              }
              return
            }
            if (hoveredEmulatorRef.current !== null) {
              setValues(hoveredEmulator, data.data, true)
            }
          }

          hoveredEmulatorRef.current = hoveredEmulator

          if (
            hoveredEmulator &&
            hoveredEmulator.id !== connectedEmulatorRef.current?.id
          ) {
            fetchAndUpdateTableValues(hoveredEmulator, true)
            return
          }
          // if null or undefined, set the values to the connected emulator if it exists
          if (hoveredEmulator === null || hoveredEmulator === undefined) {
            if (
              connectedEmulatorRef.current !== null &&
              connectedEmulatorRef.current !== undefined
            ) {
              setValues(
                connectedEmulatorRef.current,
                tripDataRef.current,
                false
              )
              return
            }
            // if both hovered and connected are null or undefined, set the values to null
            if (
              (connectedEmulatorRef.current === null ||
                connectedEmulatorRef.current === undefined) &&
              (hoveredEmulator === null || hoveredEmulator === undefined)
            ) {
              setValues(null, null, false)
            }
          }
        }
      ),
    [setValues]
  )

  // Start observing the elements when the component is mounted
  useEffect(() => {
    let initialLoad = true
    const observer = new ResizeObserver((entries) => {
      if (initialLoad) {
        initialLoad = false
        return
      }
      for (const entry of entries) {
        // save the width in local storage unless they go to 0
        if (entry.target.clientWidth === 0) {
          return
        }
        localStorage.setItem(
          `addressWidth${entry.target.id}`,
          entry.target.clientWidth
        )
      }
    })

    elementRefs.current.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current)
      }
    })

    return () => {
      // Cleanup the observer by unobserving all elements
      observer.disconnect()
    }
  }, [])

  return (
    <div
      style={{
        width: '100%'
      }}
    >
      {/* CURRENT ADDRESS */}
      <div className="info-card">
        <p
          className="central-clock"
          title="US Central time (America/Chicago)"
        >
          {centralTime}
        </p>
        <h4>Current location</h4>
        <p id="0">
          {getSelectedEmulator !== null && tripDataRef.current !== null &&
          updatedHasTripEmulatorSsid === getSelectedEmulator?.emulatorSsid &&
          emulatorLatitude &&
          emulatorLongitude
            ? currentLocation
            : 'N/A'}
        </p>

        {/* FROM ADDRESS */}
        <div className="d-flex from-to-section">
          <div className="section">
            <h4>From address</h4>
            <p
              className="current-from-address-content-width-align"
              ref={elementRefs.current[1]}
              id="1"
            >
              N/A
            </p>
          </div>

          {/* TO ADDRESS */}
          <div className="section right-section">
            <h4>To address</h4>
            <p ref={elementRefs.current[2]} id="2">
              N/A
            </p>
          </div>
        </div>

        {/* TOTAL TIME */}
        <div className="d-flex total-remaining-distance">
          <div className="section">
            <h4 className="bold-text">Total Time</h4>
            <p
              className="total-time-content-width-align"
              ref={elementRefs.current[4]}
              id="4"
            >
              N/A
            </p>
          </div>

          {/* REMAING DISTANCE */}
          <div className="section right-section">
            <h4 className="bold-text">Remaining Distance</h4>
            <p id="5" ref={elementRefs.current[5]}>
              N/A
            </p>
          </div>
        </div>

        {/* ARRIVAL TIME */}
        <div className="d-flex total-remaining-distance">
          <div className="section">
          <h4 className="bold-text">Depart/Arrival time</h4>
          <h4>(CST)</h4>
            <p id="3" ref={elementRefs.current[3]}>
              N/A
            </p>
          </div>

          {/* SPEED MPH */}
          <div className="section right-section">
            <h4 className="bold-text">Speed</h4>
            <p>
              {tripDataRef.current && tripDataRef.current.velocity != null
                ? (tripDataRef.current.velocity * 2.23694).toFixed(1)
                : '0'} MPH
            </p>
          </div>
        </div>

        {/* Progress Indicators */}
        <div className="d-flex">
          <div className="section">
            <h4 className="bold-text">Progress Indicator</h4>
            <p id="6">
              {getSelectedEmulator !== null && tripDataRef.current !== null &&
              updatedHasTripEmulatorSsid === getSelectedEmulator?.emulatorSsid &&
              updatedProgressPercentage &&
              updatedProgressTime
                ? updatedProgressPercentage + '%' + ' ' + updatedProgressTime
                : '0% 0 days 0 hours'}
            </p>
          </div>

          {/* Time Zone */}
          <div className="section right-section">
            <h4 className="bold-text">Timezone</h4>
            <p>
              {getSelectedEmulator !== null && tripDataRef.current !== null &&
              updatedHasTripEmulatorSsid === getSelectedEmulator?.emulatorSsid &&
              emulatorLatitude &&
              emulatorLongitude
                ? timeZone : 'N/A'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddressTable

function calculateRemainingDistance(tripData, emulator) {
  function formatTime(milliseconds) {
    // hours and minutes from milliseconds
    const hours = Math.floor(milliseconds / 3600000)
    const minutes = Math.floor((milliseconds % 3600000) / 60000)
    return `${hours}h ${minutes}m`
  }

  if (
    tripData === null ||
    tripData === undefined ||
    emulator === undefined ||
    emulator === null
  ) {
    return { remainingTime: 'N/A', remainingDistance: 'N/A' }
  }

  let remainingDriveTimeInMilliseconds = 'N/A'
  let remainingDistanceInMeters = 'N/A'

  const stops = tripData?.stops || []
  const breaks = tripData?.breaksV2 || []

  const tripDataPoints = tripData?.tripPoints || []
  const currentTripPointIndex = emulator.currentTripPointIndex

  // if currentTripPointIndex is more than middle of the tripPoints, then we need to calculate the remaining distance and time

  // get the remaining tripPoints by iterating below the currentTripPointIndex then delete the distance from totalDistance
  const traveledDistance = tripDataPoints.reduce((acc, tripPoint, index) => {
    if (index < currentTripPointIndex) {
      return acc + tripPoint.distance
    }
    return acc
  }, 0)
  remainingDistanceInMeters = tripData.distance - traveledDistance
  remainingDriveTimeInMilliseconds =
    remainingDistanceInMeters / emulator.velocity

  console.log('remainingTime', remainingDriveTimeInMilliseconds)
  console.log('remainingDistance', remainingDistanceInMeters)

  const totalTimeTrue =
    emulator?.arrivalTimeInUtc && emulator?.departTimeInUtc
      ? formatTime(emulator.arrivalTimeInUtc - emulator.departTimeInUtc)
      : 'N/A'

  const totalTime = tripData
    ? formatTime(tripData.distance / emulator.velocity)
    : 'N/A'

  console.log('totalTimeTrue', totalTimeTrue)
  console.log('totalTime', totalTime)
  console.log(
    'remainingDriveTimeInMilliseconds',
    remainingDriveTimeInMilliseconds
  )
  console.log('remainingDistance', remainingDistanceInMeters)
  console.log('totalDistance', tripData.distance)
  // for each stop Point whose tripPointIndex is greater than currentTripPointIndex, add the waitTime to const totalStopWaitTime
  const totalStopWaitTime = stops.reduce((acc, stopPoint) => {
    // if (stopPoint.tripPointIndex > currentTripPointIndex) {
    //   return acc + stopPoint.waitTime
    // }
    return acc + stopPoint.waitTime
  }, 0)

  const totalBreakWaitTime = breaks.reduce((acc, breakPoint) => {
    // if (breakPoint.tripPointIndex > currentTripPointIndex) {
    //   return acc + breakPoint.waitTime
    // }
    return acc + breakPoint.waitTime
  }, 0)

  console.log('totalBreakWaitTime', totalBreakWaitTime)
  console.log('totalStopWaitTime', totalStopWaitTime)

  const driveTime = (emulator.arrivalTimeInUtc - emulator.departTimeInUtc) - (totalBreakWaitTime + totalStopWaitTime)
  const stopTime = totalBreakWaitTime + totalStopWaitTime
  const remainingTime = `Drive: ${formatTime(driveTime)} + Stops: ${formatTime(stopTime)}<br/> = ${totalTimeTrue}`

  const remainingDistance =
    parseInt(remainingDistanceInMeters / 1609) + ' miles'

  return { remainingTime, remainingDistance }
}

// function readableTime(time) {
//   const date = new Date(time)
//   const options = {
//     hour: 'numeric',
//     minute: '2-digit',
//     hour12: true,
//     day: '2-digit',
//     month: 'short',
//     year: 'numeric',
//     timeZone: 'UTC'
//   }
//   return date.toLocaleString('en-US', options)
// }
